import React from "react"

const EmptyState = () => (
  <div className="py-4 text-center text-sm text-gray-500">No activity yet.</div>
)

export default EmptyState
